import { initializeApp } from "firebase/app";
import { getDatabase, ref, get } from "firebase/database";
import env from "../config/env.json";

const ENV = env.ENV;

const init = async () => {
  try {
    const dbInstance = initializeApp(env[ENV].FIREBASE);
    const db = getDatabase(dbInstance);
    return db;
  } catch (e) {
    return null;
  }
};

export const getCountryCodes = async (key = "countryCodes") => {
  try {
    const db = await init();
    const itemsRef = ref(db, key);
    const snapshot = await get(itemsRef);

    if (snapshot.exists()) {
      return snapshot.val() || [];
    } else {
      return []; // Retorna null si no hay datos
    }
  } catch (e) {
    return [];
  }
};